import React from 'react';

const TeacherProfileCard = () => {
  const AWS = process.env.REACT_APP_AWS_HOST;
  const teacher = {
    name: sessionStorage.getItem('first_name') + ' ' + sessionStorage.getItem('last_name'),
    image: sessionStorage.getItem('profile_image'),
    profileType: "Program Instructor"
  };

  const handleViewProfile = () => {
    window.location.href = '/teacher-profile-edit';
  };

  return (
    <div>
      <div className="teacher-card blueborder">
        <img 
          src={`${AWS}${teacher.image}`}
          alt={teacher.name}
          className="profile-image"
        />
        <div className="teacher-info">
          <h3 className="teacher-name">{teacher.name}</h3>
          <p className="profile-type">{teacher.profileType}</p>
          <button 
            className="btn-view-profile"
            onClick={handleViewProfile}
            type="button"
          >
            View Profile
          </button>
        </div>
      </div>

      <style>{`

        .teacher-card {
          height: 210px;
          background: rgba(255, 255, 255, 0.98);
          backdrop-filter: blur(20px);
          padding: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 20px;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
        }

        .teacher-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #667eea);
          background-size: 200% 100%;
          animation: gradientShift 3s ease infinite;
        }

        @keyframes gradientShift {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }

        .teacher-card::after {
          content: '';
          position: absolute;
          top: -50%;
          right: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(102, 126, 234, 0.08) 0%, transparent 70%);
          opacity: 0;
          transition: opacity 0.4s ease;
        }

        .teacher-card:hover::after {
          opacity: 1;
        }

        .profile-image {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          object-fit: cover;
          border: 4px solid #ffffff;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15), 0 0 0 2px rgba(102, 126, 234, 0.1);
          flex-shrink: 0;
          transition: all 0.4s ease;
        }

        .teacher-card:hover .profile-image {
          transform: scale(1.08) rotate(2deg);
          box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2), 0 0 0 3px rgba(102, 126, 234, 0.3);
        }

        .teacher-info {
          text-align: left;
          flex: 1;
        }

        .teacher-name {
          font-size: 20px;
          font-weight: 700;
          background: linear-gradient(135deg, #1a202c 0%, #2d3748 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin: 0 0 8px;
          letter-spacing: -0.5px;
        }

        .profile-type {
          font-size: 14px;
          color: #667eea;
          margin: 0 0 16px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .btn-view-profile {
          padding: 12px 24px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: #ffffff;
          border: none;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 16px rgba(102, 126, 234, 0.35);
          position: relative;
          overflow: hidden;
          z-index: 1;
        }

        .btn-view-profile::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          transition: left 0.5s ease;
          z-index: -1;
        }

        .btn-view-profile:hover::before {
          left: 100%;
        }

        .btn-view-profile:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 24px rgba(102, 126, 234, 0.45);
        }

        .btn-view-profile:active {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.35);
        }

        @media (max-width: 576px) {
          .teacher-card {
            max-width: 100%;

          }
        }
      `}</style>
    </div>
  );
};

export default TeacherProfileCard;
